function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { reduce, isEmpty, isEqualWith, isArray, differenceWith, isEqual } from 'lodash-es';
import xss from 'xss';
import { stringifyError } from '@shared/utils/errorUtils';
import { logger } from '@src/logger';
const objCompare = (obj1, obj2)=>{
    return isEqualWith(obj1, obj2, function(v1, v2, key) {
        if (key === undefined) {
            return undefined;
        }
        if (v1 === v2) {
            return true;
        }
        if (isArray(v1) && isArray(v2)) {
            if (isEmpty(differenceWith(v1, v2, isEqual))) {
                return true;
            }
        }
        return false;
    });
};
const recursiveDecode = ({ value, run = 3 })=>{
    if (run <= 0) {
        return value;
    }
    const decodedValue = decodeURIComponent(value);
    return decodedValue === value ? value : recursiveDecode({
        value: decodedValue,
        run: --run
    });
};
const parseQuery = ({ query = {}, parser })=>reduce(query, (acc, value, key)=>{
        const decodedValue = isArray(value) && value.map((arrayValue)=>parser(arrayValue)) || parser(value);
        return _object_spread_props(_object_spread({}, acc), {
            [parser(key)]: decodedValue
        });
    }, {});
const decodeString = (value)=>recursiveDecode({
        value
    });
const xssDecodeString = (value)=>{
    return xss(decodeString(value));
};
const decodeQuery = (query)=>{
    return parseQuery({
        query,
        parser: (value)=>decodeString(value)
    });
};
const xssDecodeQuery = (query)=>{
    return parseQuery({
        query,
        parser: (value)=>xssDecodeString(value)
    });
};
export const getXssDiff = ({ req: { url, query } })=>{
    let hasDiff = false;
    try {
        const decodedUrl = decodeString(JSON.parse(`"${url}"`));
        const xssDecodedUrl = xssDecodeString(decodedUrl);
        const hasUrlDiff = decodedUrl !== xssDecodedUrl;
        const decodedQuery = decodeQuery(query);
        const xssDecodedQuery = xssDecodeQuery(query);
        const hasQueryDiff = !objCompare(decodedQuery, xssDecodedQuery);
        hasDiff = hasQueryDiff || hasUrlDiff;
    } catch (e) {
        hasDiff = true;
        logger.debug(stringifyError({
            msg: 'failed to parse query diff',
            err: e
        }), {
            action: 'xssMiddleware'
        });
    }
    return hasDiff;
};
export const getXssDiffString = ({ url })=>{
    const urlObject = new URL(url);
    return getXssDiff({
        req: {
            url: urlObject.pathname,
            query: Object.fromEntries(urlObject.searchParams)
        }
    });
};
